import React from 'react';
import { FlexColumn } from '@guryou/html-components';
import { borderDefinition, boxShadow, smallBorderRadius } from '@guryou/html-theme';

const PreviewVideo = () => {
  return <FlexColumn xs={8} boxShadow={boxShadow} borderRadius={smallBorderRadius} border={borderDefinition()}></FlexColumn>;
};

export default PreviewVideo;
